define.alias("shared/components/shared/credentials/instagram-auth-status", "preview-grid/components/shared/credentials/instagram-auth-status");